module.exports = __webpack_public_path__ + "cb925de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/map_marker_5.png
// module id = 1675
// module chunks = 0